export default "__VITE_ASSET__SMdsC8OJ__"